import { Provider } from 'react-redux';

import store from '../../store';

import ErrorProvider from '../ErrorProvider';

const AppProvider = ({ children }) => (
    <Provider store={store}>
        <ErrorProvider>{children}</ErrorProvider>
    </Provider>
);

export default AppProvider;
